import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject } from 'rxjs';

export const LIVE_CHAT_DELAY = 5000;

declare let LiveChatWidget: {
  call: (command: string, args?: unknown) => void,
};

@Injectable({ providedIn: 'root' })
export class LiveChatService {
  private readonly _platformId = inject(PLATFORM_ID);

  private _deniedLocations = [
    /^\/cabinet\/(logout)$/,
  ];

  public initialized = new BehaviorSubject(false);

  constructor(
    private _zone: NgZone
  ) {}

  public init(): void {
    const enabled =
      isPlatformBrowser(this._platformId) && undefined ===
      this._deniedLocations.find(loc => {
        return !!location.pathname.match(loc);
      });

    if (enabled) {
      const s = document.createElement('script');

      // eslint-disable-next-line max-len
      s.innerHTML = `window.__lc = window.__lc || {};window.__lc.license = ${environment.liveChatToken};(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))`;

      this._zone.runOutsideAngular(() => {
        window.setTimeout(() => {
          document.body.appendChild(s);
          this.initialized.next(true);
        }, LIVE_CHAT_DELAY);
      });
    }
  }

  public addTag(tag: string): void {
    if (this.initialized.value) {
      LiveChatWidget.call('set_session_variables', {tag});
    }
  }

  public hide(): void {
    if (this.initialized.value && (<any>window).LiveChatWidget) {
      LiveChatWidget.call('minimize');
    }
  }

  public activate(): void {
    if (this.initialized.value && (<any>window).LiveChatWidget) {
      LiveChatWidget.call('maximize');
    }
  }
}
